import { combineReducers } from 'redux';
import Docs from 'bundles/project/reducers/docs';
import Tasks from 'bundles/project/reducers/tasks';
import Ui from 'bundles/project/reducers/ui';
import Project from 'components/project/reducers/project_reducer';
import TaskModal from 'components/project/reducers/task_modal';
import Assignment from './assignment';

const rootReducer = combineReducers({
  assignment: Assignment,
  availableDatabaseOptions: state => state || [],
  contactRoles: state => state || [],
  docs: Docs,
  features: state => state || {},
  project: Project,
  taskModal: TaskModal,
  taskOptions: state => state || {},
  tasks: Tasks,
  ui: Ui
});

export default rootReducer;
